(() => {
  const enableToggleIfInactive = () => {
    const upCart = document.querySelector("#upCart");
    if (!upCart?.shadowRoot) return false;

    const shadow = upCart.shadowRoot;
    const toggle = shadow.querySelector(".styles_AddonsModule__toggle__.upcart-addons-toggle");
    const circle = toggle?.querySelector(".styles_ToggleSwitch__circle__");
    const switchWrapper = toggle?.querySelector(".styles_ToggleSwitch__");

    if (circle && switchWrapper && !switchWrapper.classList.contains("styles_ToggleSwitch--active__")) {
      circle.click();
      
      return true;
    }
    return false;
  };

  let lastCartVisible = false;

  const observer = new MutationObserver(() => {
    const upCart = document.querySelector("#upCart");
    const isVisible = upCart && getComputedStyle(upCart).display !== "none";

    if (isVisible && !lastCartVisible) {
    
      const shadowCheck = setInterval(() => {
        if (enableToggleIfInactive()) clearInterval(shadowCheck);
      }, 50);
    }

    lastCartVisible = isVisible;
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();